import { render, staticRenderFns } from "./LegacySimpleTableComponent.vue?vue&type=template&id=20f174e3&"
import script from "./LegacySimpleTableComponent.vue?vue&type=script&lang=ts&"
export * from "./LegacySimpleTableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f174e3')) {
      api.createRecord('20f174e3', component.options)
    } else {
      api.reload('20f174e3', component.options)
    }
    module.hot.accept("./LegacySimpleTableComponent.vue?vue&type=template&id=20f174e3&", function () {
      api.rerender('20f174e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/models/Table/Legacy/LegacySimpleTableComponent.vue"
export default component.exports